module.exports = __webpack_public_path__ + "img/homebg.374847ae.jpg";